<main class="reference_form-main">
  <div class="main_container">
    <form [formGroup]="companyfunctionForm">
    <div class="">
      <h3 class="form_name">Function</h3>


        <div class="input">
          <label for="">Function Name</label>
          <input type="text" class="default_input reference-form" formControlName="FunctionName" />
        </div>


      <div class="btn_holder">
        <button class="default_primary-button" *ngIf="selectedIndex === null"
          (click)="addNew(companyfunctionForm.value)">Add</button>
        <button class="default_primary-button" *ngIf="selectedIndex !== null"
          (click)="addNew(companyfunctionForm.value)">Update</button>
        <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>

      </div>

    </div>
  </form>
    <div class="display_table" >
      <div class="search_container">
        <input type="text" class="default_input search"
        placeholder="Search for CompanyFunction"
        [formControl]="control"
        [appAutocomplete]="autocomplete"
        />
        <em class="ti-search"></em> 

        <app-autocomplete #autocomplete="appAutocomplete">
          <ng-template appAutocompleteContent>
            <ng-container
              *ngIf="(companys | filterReference: control.value) as result"
            >
              <app-option
                (click)="selectCompany(option.id)"
                *ngFor="let option of result"
                [value]="option.CompanyName"
              >
                {{ option.CompanyName }}
              </app-option>
              <app-option class="no-result" *ngIf="!result.length"
                >No result...</app-option
              >
            </ng-container>
          </ng-template>
        </app-autocomplete>
      </div>

      <div class="head" >
        <span class="item">S/N</span>
        <span class="item">Function Name</span>
        <span class="item">Action</span>

      </div>

    <div class="scroll">

    </div>
    <div class="body_content" *ngIf="status">
      <div class="the_body"
      *ngFor="let companyfunction of companyfunctionFormArray.get('CompanyFunctions')['controls']; index as i"
      (click)="onEdit(i, companyfunction.value)" style="cursor: pointer;"
      matTooltip="Click to edit"
        aria-label="Button that displays a tooltip when focused or hovered over"
      >
        <span class="content">{{i + 1}}</span>
        <span class="content">{{companyfunction.value.FunctionName}}</span>
        <span class="content" (click)="$event.stopImmediatePropagation()">
          <button
          class="delete_icon trash"

          (click)="deleteCompanyFunction(i, companyfunction.value)">
          <em class="ti-trash"> </em> </button>
        </span>

      </div>
      </div>
      <div class="btn_holder">
        <button class="default_primary-button" (click)="onSubmit(companyfunctionFormArray.value)">Submit</button>
      </div>
    </div>
  </div>
</main>

<div class="box green_box"></div>
<div class="box pink_box"></div>
